/**
 * @Author: DJ
 * @Date:   2021-07-08 15:54:01
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-28 10:25:57
 */
import { createModel } from '@/store/tools';

const model = {
    namespace: 'rider',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getRiderList': T('getRiderList'),
            'getScoreCompare': T('getScoreCompare'),
            'getRiderStateList': T('getRiderStateList'),
            'getRiderLevelList': T('getRiderLevelList'),
            'getRiderDetail': T('getRiderDetail'),
            'getPunishmentReason': T('getPunishmentReason'),
            'getRiderLevelScore': T('getRiderLevelScore'),
            'getRecommentList': T('getRecommentList'),
            'getFriendList': T('getFriendList'),
            'getJiangFaDetailList': T('getJiangFaDetailList'),
            'getInsurePolicyListByRiderId': T('getInsurePolicyListByRiderId'),
            'getInsurePolicyStatistics': T('getInsurePolicyStatistics'),
            'getJiangFaResultEnum': T('getJiangFaResultEnum'),
            'getChannelTypetEnum': T('getChannelTypetEnum'),
            'getRiderAccountSummary': T('getRiderAccountSummary'),
            'getOperateType': T('getOperateType'),
            'getRiderTotalIncome': T('getRiderTotalIncome'),
            'getRiderTotalDrawable': T('getRiderTotalDrawable'),
            'getDistributionFlowList': T('getDistributionFlowList'),
        },
        actions: {
            'getRiderList': A('getRiderList'),
            'getScoreCompare': A('getScoreCompare', { enumName: 'CompareEnum' }),
            'getRiderStateList': A('getRiderStateList', { enumName: 'RiderStatusEnum' }),
            'getRiderLevelList': A('getRiderLevelList'),
            'getRiderDetail': A('getRiderDetail'),
            'getPunishmentReason': A('getPunishmentReason'),
            'getRiderLevelScore': A('getRiderLevelScore'),
            'getRecommentList': A('getRecommentList'),
            'getFriendList': A('getFriendList'),
            'getJiangFaDetailList': A('getJiangFaDetailList'),
            'getInsurePolicyListByRiderId': A('getInsurePolicyListByRiderId'),
            'getInsurePolicyStatistics': A('getInsurePolicyStatistics'),
            'getJiangFaResultEnum': A('getJiangFaResultEnum', { enumName: 'PunishmentStateEnum' }),
            'getChannelTypetEnum': A('getChannelTypetEnum', { enumName: 'RiderInsurePaymentChannelTypeEnum'}),
            'getRiderAccountSummary': A('getRiderAccountSummary'),
            'getOperateType': A('getOperateType', { enumName: 'TransTypeEnum' }),
            'getRiderTotalIncome': A('getRiderTotalIncome'),
            'getRiderTotalDrawable': A('getRiderTotalDrawable'),
            'getDistributionFlowList': A('getDistributionFlowList'),
        },
        sagas: {
            'getRiderList': S('getRiderList', '/?cmd=com.xqxc.api.pig.mis.biz.account.RiderAccountMisService.riderList'),
            'getScoreCompare': S('getScoreCompare', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getRiderStateList': S('getRiderStateList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getRiderLevelList': S('getRiderLevelList', '/?cmd=com.xqxc.api.pig.mis.biz.account.AcRiderLevelMisService.list'),
            'getRiderDetail': S('getRiderDetail', '/?cmd=com.xqxc.api.pig.mis.biz.account.RiderAccountMisService.riderDetail'),
            'getPunishmentReason': S('getPunishmentReason', '/?cmd=com.xqxc.api.pig.mis.order.PunishmentTypeService.findNames'),
            'getRiderLevelScore': S('getRiderLevelScore', '/?cmd=com.xqxc.api.pig.mis.biz.account.RiderAccountMisService.levelScoreLogList'),
            'getRecommentList': S('getRecommentList', '/?cmd=com.xqxc.api.pig.mis.biz.account.RiderAccountMisService.recommentList'),
            'getFriendList': S('getFriendList', '/?cmd=com.xqxc.api.pig.mis.biz.account.RiderAccountMisService.friendList'),
            'getJiangFaDetailList': S('getJiangFaDetailList', '/?cmd=com.xqxc.api.pig.mis.order.RewardService.rewardPunishmentList'),
            'getInsurePolicyListByRiderId': S('getInsurePolicyListByRiderId', '/?cmd=com.xqxc.api.pig.mis.biz.rider.RiderMisService.getInsurePolicyListByRiderId'),
            'getInsurePolicyStatistics': S('getInsurePolicyStatistics', '/?cmd=com.xqxc.api.pig.mis.biz.rider.RiderMisService.getInsurePolicyStatistics'),
            'getJiangFaResultEnum': S('getJiangFaResultEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getChannelTypetEnum': S('getChannelTypetEnum', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getRiderAccountSummary': S('getRiderAccountSummary', '/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountApiMisService.selectRiderSettleAccount'),
            'getOperateType': S('getOperateType', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getRiderTotalIncome': S('getRiderTotalIncome', '/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.riderTotalBalanceList'),
            'getRiderTotalDrawable': S('getRiderTotalDrawable', '/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.totalWithdrawList'),
            'getDistributionFlowList': S('getDistributionFlowList', '/?cmd=com.xqxc.api.pig.mis.settle.SmallTransportTransDetailMisService.list'),
        },
        reducers: {
            'getRiderList': R('getRiderList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getScoreCompare': R('getScoreCompare', []),
            'getRiderStateList': R('getRiderStateList', []),
            'getRiderLevelList': R('getRiderLevelList', []),
            'getRiderDetail': R('getRiderDetail', {}),
            'getPunishmentReason': R('getPunishmentReason', []),
            'getRiderLevelScore': R('getRiderLevelScore', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getRecommentList': R('getRecommentList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getFriendList': R('getFriendList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getJiangFaDetailList': R('getJiangFaDetailList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getInsurePolicyListByRiderId': R('getInsurePolicyListByRiderId', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getJiangFaResultEnum': R('getJiangFaResultEnum', []),
            'getChannelTypetEnum': R('getChannelTypetEnum', []),
            'getRiderAccountSummary': R('getRiderAccountSummary', {}),
            'getInsurePolicyStatistics': R('getInsurePolicyStatistics', {}),
            'getOperateType': R('getOperateType', []),
            'getRiderTotalIncome': R('getRiderTotalIncome', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getRiderTotalDrawable': R('getRiderTotalDrawable', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getDistributionFlowList': R('getDistributionFlowList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
        }
    })
};
export default createModel(model);